import React, { Component } from 'react'
import { PageHeader } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';

import DemographicInfo from './DemographicInfo';
import EducationInfo from './EducationInfo';
import OtherInfo from './OtherInfo';
import LoaderButton from './LoaderButton';

import demographicValidation from '../libs/demographicValidation';
import educationValidation from '../libs/educationValidation';
import otherValidation from '../libs/otherValidation';
import { statusTypes } from '../config/constants';
import * as types from '../actions/types'

import {
  addCollege,
  updateCollege,
  removeCollege,
  addDegree,
  updateDegree,
  removeDegree,
  updateApplication
} from '../actions';
import { debugLog } from "../libs/app";

class Form extends Component {
  constructor(props){
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleAddCollege = this.handleAddCollege.bind(this);
    this.handleUpdateCollege = this.handleUpdateCollege.bind(this);
    this.handleRemoveCollege = this.handleRemoveCollege.bind(this);
    this.handleAddDegree = this.handleAddDegree.bind(this);
    this.handleUpdateDegree = this.handleUpdateDegree.bind(this);
    this.handleRemoveDegree = this.handleRemoveDegree.bind(this);
    this.handleChanges = this.handleChanges.bind(this);
    this.handleSubmitApplication = this.handleSubmitApplication.bind(this);
  }

  handleSubmitApplication(e) {
    e.preventDefault();
    debugLog('Submitting Application');
    this.props.onSubmit();
  }

  componentDidMount() {
    if(!this.props.authState.isAuthenticated)
      this.props.history.push('/');
  }

  componentDidUpdate() {
    if(this.props.complete)
      this.props.history.push('/application');
  }

  handleChange(e) {
    let updates = {};
    updates[e.target.id] = e.target.value;
    this.handleChanges(updates);
  }

  handleChanges(updates) {
    const { dispatch } = this.props;
    dispatch(updateApplication(updates));
  }

  handleAddCollege(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch(addCollege());
  }

  handleUpdateCollege(collegeId, updates) {
    const { dispatch } = this.props;
    dispatch(updateCollege(collegeId, updates));
  }

  handleRemoveCollege(collegeId) {
    const { dispatch } = this.props;
    dispatch(removeCollege(collegeId));
  }

  handleAddDegree(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch(addDegree());
  }

  handleUpdateDegree(degreeId, updates) {
    const { dispatch } = this.props;
    dispatch(updateDegree(degreeId, updates));
  }

  handleRemoveDegree(degreeId) {
    const {dispatch} = this.props;
    dispatch(removeDegree(degreeId));
  }

  render() {
    const { educationInfo, demographicInfo, otherInfo, termApplying, complete, isSubmitting } = this.props;
    const educationValidationStatus = educationValidation.getValidationStatus(educationInfo);
    const demographicValidationStatus = demographicValidation.getValidationStatus(demographicInfo);
    const otherValidationStatus = otherValidation.getValidationStatus(otherInfo);
    const canSubmit = educationValidationStatus.section.status === statusTypes.SUCCESS &&
      demographicValidationStatus.section.status === statusTypes.SUCCESS &&
      otherValidationStatus.section.status === statusTypes.SUCCESS;
    return (
      <div className="container">
        <PageHeader>
          Application For Services <small>{termApplying}</small>
        </PageHeader>
        <DemographicInfo
          {...demographicInfo}
          onChange={this.handleChanges}
          validationStatus={demographicValidationStatus}
        />
        <EducationInfo
          {...educationInfo}
          onChange={this.handleChanges}
          onAddCollege={this.handleAddCollege}
          onUpdateCollege={this.handleUpdateCollege}
          onRemoveCollege={this.handleRemoveCollege}
          onAddDegree={this.handleAddDegree}
          onUpdateDegree={this.handleUpdateDegree}
          onRemoveDegree={this.handleRemoveDegree}
          validationStatus={educationValidationStatus}
        />
        <OtherInfo
          {...otherInfo}
          onChange={this.handleChanges}
          validationStatus={otherValidationStatus}
        />
        {!complete &&
        <LoaderButton
          onClick={this.handleSubmitApplication}
          disabled={!canSubmit}
          isLoading={isSubmitting}
          text='Submit Application'
          loadingText='Submitting Application'
          glyph='check'
        />
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { application, appInfo } = state;
  const { appOpenForStudents: alive } = appInfo.openTerm;
  const isSubmitting = appInfo.isInvoking && (appInfo.invokingType === types.SUBMIT_APPLICATION_REQUEST);
  const falseFlag = false;
  const {
    ethnicity,
    deltaId,
    phones,
    address,
    name,
    gender,
    email,
    dateOfBirth,
    maritalStatus,
    hsName,
    hsGpa,
    hsDiploma,
    hsGed,
    hsForeignDiploma,
    colleges,
    collegeUnits,
    collegeMajor,
    collegeGrad,
    degrees,
    edGoalDegree,
    edGoalCertificate,
    edGoalTransfer,
    sjdcEops,
    otherEops,
    sjdcDsps,
    motherEdLevel,
    fatherEdLevel,
    motherLanguage,
    fatherLanguage,
    fosterYouth,
    veteran,
    headOfHousehold,
    ab540,
    cashAid,
    calworks,
    dependents,
    termApplying,
    complete
  } = application;
  return {
    alive,
    termApplying,
    complete,
    isSubmitting,
    falseFlag,
    educationInfo: {
      hsName,
      hsGpa,
      hsDiploma,
      hsGed,
      hsForeignDiploma,
      colleges,
      collegeMajor,
      collegeUnits,
      edGoalDegree,
      edGoalCertificate,
      edGoalTransfer,
      collegeGrad,
      degrees
    },
    demographicInfo: {
      studentEthnicity: ethnicity,
      deltaId,
      gender,
      phones,
      address,
      name,
      email,
      dateOfBirth,
      maritalStatus
    },
    otherInfo: {
      sjdcEops,
      otherEops,
      sjdcDsps,
      motherEdLevel,
      fatherEdLevel,
      motherLanguage,
      fatherLanguage,
      fosterYouth,
      veteran,
      headOfHousehold,
      ab540,
      cashAid,
      calworks,
      dependents
    }
  }
}

export default connect(mapStateToProps)(withOktaAuth(Form));